export const CSC_TASK_CONFIRMATION_METHOD: { [index: number]: string } = {
    0: '',
    1: 'RFID',
    2: 'Terminal',
};
